import { getTimeSpanParts } from '@ancon/wildcat-utils/time'

export default function getFormattedPrepTime(
  preptime: string | null,
  translate: any,
) {
  if (!preptime) return ''
  const formattedPrepTime = getTimeSpanParts(preptime)

  if (formattedPrepTime && formattedPrepTime?.hours > 0) {
    return `${formattedPrepTime.hours} ${translate('hours')} ${
      formattedPrepTime.minutes
    } ${translate('minutes')}`
  }

  return `${formattedPrepTime?.minutes ?? 0} ${translate('minutes')}`
}
